import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import { Facebook, Instagram } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const footerLinkColor = '#b39ddb'; // Material UI Purple 200 - good contrast on dark

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        backdropFilter: 'blur(10px)',
        color: footerLinkColor,
        padding: '3rem 1rem',
        textAlign: 'center',
        boxShadow: '0 -4px 10px rgba(0, 0, 0, 0.2)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box sx={{ marginBottom: '2rem' }}>
        <Typography
          variant="h2"
          sx={{
            marginBottom: '1rem',
            fontWeight: 'bold',
            color: footerLinkColor,
            fontSize: {
              xs: '2rem', // mobile
              sm: '2.2rem',   // tablet
              md: '2.5rem', // desktop
            },
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          {t('footer.contactUs')}
        </Typography>
        <Typography>
          <Link
            href="tel:+48459116490"
            sx={{
              display: 'inline-block',
              padding: '0.5rem 0',
              textDecoration: 'underline',
              color: footerLinkColor,
              fontWeight: 'bold',
            }}
          >
            {t('footer.phone')}
          </Link>
        </Typography>
        <Typography>
          <Link
            href="mailto:quadtrip.szczecin@gmail.com"
            sx={{
              display: 'inline-block',
              padding: '0.5rem 0',
              textDecoration: 'underline',
              color: footerLinkColor,
              fontWeight: 'bold',
            }}
          >
            {t('footer.email')}
          </Link>
        </Typography>
        <Typography>
          <Link
            href="https://www.google.pl/maps/place/quadtrip/@53.3716662,14.6061428,17z/data=!3m1!4b1!4m6!3m5!1s0x4700a74b1d6483fb:0x942e6bf0a8ac274e!8m2!3d53.3716662!4d14.6087231!16s%2Fg%2F11xgrh0qgm"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-block',
              padding: '0.5rem 0',
              textDecoration: 'underline',
              color: footerLinkColor,
              fontWeight: 'bold',
            }}
          >
            {t('footer.address')}
          </Link>
        </Typography>
      </Box>
      <Box sx={{ marginBottom: '1.5rem' }}>
        <Link
          href="https://facebook.com/61576691327287/"
          aria-label="Facebook"
          sx={{
            color: footerLinkColor,
            margin: '0 1rem',
            transition: 'color 0.3s ease',
            '&:hover': {
              color: '#d1b3ff', // Even lighter purple on hover
            },
          }}
        >
          <Facebook fontSize="large" />
        </Link>
        <Link
          href="https://www.instagram.com/quadtrip_szczecin/"
          aria-label="Instagram"
          sx={{
            color: footerLinkColor,
            margin: '0 1rem',
            transition: 'color 0.3s ease',
            '&:hover': {
              color: '#d1b3ff',
            },
          }}
        >
          <Instagram fontSize="large"/>
        </Link>
      </Box>

      <Image
        src="/images/wypozyczalnia-quadow-szczecin-quadtrip-logo.webp"
        alt="Quadtrip logo"
        width={200}
        height={200}
      />

      <Typography variant="body2" sx={{ color: footerLinkColor }}>
        &copy; {new Date().getFullYear()} {t('footer.companyName')}. {t('footer.rightsReserved')}
      </Typography>
    </Box>
  );
};

export default Footer;